<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="v_tableData"
      :columns="tableColumns"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      :height="500"
      :cell-class-name="'align-top'"
      :toolbar-config="tableToolbar"
      :edit-rules="validRules"
      @edit-closed="subTotAmount"
      show-footer
      :footer-method="() => footerData"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span class="side-frame-text" style="font-weight: 600;">
              {{ $l('table_label_add_departments') || '增加分摊部门' }}
            </span>
            <el-divider direction="vertical"></el-divider>

            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="add()"
              ><i class="el-icon-plus" />{{
                $l('table_label_product_dialog_btn_add') || '添加'
              }}
            </b-button>
          </div>
        </slot>
      </template>

      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_delete') || '删除'"
          placement="top"
        >
          <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
        </el-tooltip>
      </template>

      <template v-slot:depCode="{ row }">
        <dep-cascader
          size="mini"
          ref="dep"
          :lastValue.sync="row.depCode"
          :valueString.sync="row.displayDepCode"
          :pathLabels.sync="row.orgDepFullName"
          :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
        />
      </template>
      <template v-slot:fabricInfo="{ row }">
        <span>{{ row.fabricNo }}</span>
        <br />
        <span>{{ row.fabricName }}</span>
        <br />
        <span> {{ row.fabricContent }} </span>
      </template>
      <template v-slot:widAndWeight="{ row }">
        <span>{{ row.wid }} {{ row.widUnit }}</span>
        <br />
        <span>{{ row.fabricWeight }} {{ row.fabricWeightUnit }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { add, multiplyRound, divideRound, format } from '@/libs/util.number.js'
import { cloneDeep } from 'lodash'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    fixedData: { type: Object, Object: () => {} },
    fabricRequestCode: { type: String, default: '' },
  },

  data() {
    return {
      formData: {},
      v_tableData: [],
      id: 1,
      format: (number) => format(number),
      tableColumns: tableColumns(this),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      validRules: {
        currencyAmount: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_currency_amount_must_be_greater_than_0') ||
              '费用金额须大于0',
          },
        ],
        requestAmount: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_fabric_amount_must_be_greater_than_0') ||
              '面料金额须大于0',
          },
        ],
        expenseType: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('form_placeholder_expenseType') || '请选择项目费用',
          },
        ],
        orgDepFullName: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('form_placeholder_allocation_department') ||
              '请选择分摊部门',
          },
        ],
        custName: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('form_placeholder_custName') || '请选择费用客户',
          },
        ],
        billCount: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('form_placeholder_billCount') || '请输入单据张数',
          },
        ],
        bizDate: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        fabricColorTitle: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        unitPrice: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        requestQuantity: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_quantity_must_be_greater_than_0') || '数量须大于0',
          },
        ],
        fabricUnit: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
    }
  },
  watch: {
    tableData: {
      handler(e) {
        if (!e || !e.length) return
        this.v_tableData = cloneDeep(e)
      },
      immediate: true,
    },
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)
      const { tableData } = this.$refs.table.getTableData()
      const totalColumnValues = tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible || c.visible === undefined)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[2] = '合计'
      return [result]
    },
  },
  methods: {
    async add() {
      const $table = this.$refs.table
      await $table.insertAt(
        {
          ...this.fixedData,
          depCode: '',
          orgDepFullName: '',
          requestQuantity: 0,
          requestAmount: 0,
          requestFee: 0,
          currencyAmount: 0,
          id: ++this.id,
        },
        -1
      )
    },
    async delRow(row) {
      this.$refs.table.remove(row)
    },
    getTableData() {
      const { fullData } = this.$refs.table.getTableData()
      return fullData
    },
    async validEvent() {
      const result = await this.$refs.table.validate(true).catch(() => true)
      if (result) return false
      const { tableData } = this.$refs.table.getTableData()
      const newArr = tableData.map((item) => item.orgDepFullName)
      const arrSet = new Set(newArr)
      if (arrSet.size === newArr.length) return true
      this.$message.warning(
        this.$l('tips_dep_name_repeat') || '分摊部门重复请检查后保存!'
      )
      return false
    },
    subTotAmount({ column = {}, row = {} }) {
      if (column) {
        const { property } = column
        if (property == 'requestAmount') {
          row.requestQuantity = divideRound(row.requestAmount, row.unitPrice, 2)
        }
        if (property == 'requestQuantity' || property == 'unitPrice') {
          row.requestAmount = multiplyRound(
            row.unitPrice,
            row.requestQuantity,
            2
          )
        }
        row.currencyAmount = add(row.requestAmount, row.requestFee)
      }
      this.$refs.table.updateFooter()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
}
</style>
